module.exports = __webpack_public_path__ + "img/1.819970d6.png";